export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
'menu.充值': 'Recharge',
  'menu.充值.充值': 'Recharge',
  'menu.充值.查看': 'View',
  'menu.卡余额提醒': 'Card Balance Reminder',
  'menu.消纳': 'Disposal',
  'menu.消纳.消纳': 'Disposal',
  'menu.消纳.新建消纳': 'New Disposal',
  'menu.消纳.编辑': 'Edit',
  'menu.消纳.查看': 'View',
  'menu.统计分析': 'Statistical Analysis',
  'menu.规则设置': 'Rule Settings',
  'menu.系统设置': 'System Settings',
  'menu.系统设置.成员管理': 'Member Management',
  'menu.系统设置.成员列表': 'Member List',
  'menu.系统设置.添加成员': 'Add Member',
  'menu.系统设置.编辑成员': 'Edit Member',
  'menu.系统设置.查看成员': 'View Member',
  'menu.系统设置.角色与权限': 'Role & Permissions',
  'menu.系统设置.角色列表': 'Role List',
  'menu.系统设置.添加角色': 'Add Role',
  'menu.系统设置.编辑角色': 'Edit Role',
  'menu.系统设置.查看角色': 'View Role',
  'menu.成员管理': 'Member Management',
  'menu.成员列表': 'Member List',
  'menu.添加成员': 'Add Member',
  'menu.编辑成员': 'Edit Member',
  'menu.查看成员': 'View Member',
  'menu.角色与权限': 'Role & Permissions',
  'menu.角色列表': 'Role List',
  'menu.添加角色': 'Add Role',
  'menu.编辑角色': 'Edit Role',
  'menu.查看角色': 'View Role',
  'menu.基本信息': 'Basic Information',
  'menu.基本信息.服务片区': 'Service Area',
  'menu.基本信息.新建片区': 'New Area',
  'menu.基本信息.编辑片区': 'Edit Area',
  'menu.基本信息.商户信息': 'Merchant Information',
  'menu.基本信息.新建商户': 'New Merchant',
  'menu.基本信息.编辑商户': 'Edit Merchant',
  'menu.基本信息.查看商户': 'View Merchant',
  'menu.基本信息.新增签订合同': 'Add Contract',
  'menu.基本信息.编辑合同': 'Edit Contract',
  'menu.基本信息.查看合同': 'View Contract',
  'menu.基本信息.新建人员': 'New Staff',
  'menu.基本信息.编辑人员': 'Edit Staff',
  'menu.基本信息.运营信息': 'Operation Information',
  'menu.服务片区': 'Service Area',
  'menu.新建片区': 'New Area',
  'menu.商户信息': 'Merchant Information',
  'menu.新建商户': 'New Merchant',
  'menu.编辑商户': 'Edit Merchant',
  'menu.查看商户': 'View Merchant',
  'menu.新增签订合同': 'Add Contract',
  'menu.编辑合同': 'Edit Contract',
  'menu.查看合同': 'View Contract',
  'menu.新建人员': 'New Staff',
  'menu.编辑人员': 'Edit Staff',
  'menu.运营信息': 'Operation Information',
  'menu.新建清运记录': 'New Transport Record',
  'menu.编辑清运记录': 'Edit Transport Record',
};
